import React from 'react';
import { motion } from 'framer-motion';

/**
 * AdvantageCard - Animated card displaying a single advantage
 * @param {Component} icon - Lucide icon component
 * @param {string} title - Card title
 * @param {string} description - Card description
 * @param {number} delay - Animation delay
 * @param {string} color - Accent color for the icon
 */
export default function AdvantageCard({ icon: Icon, title, description, delay, color }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay, duration: 0.5 }}
      whileHover={{ scale: 1.05, y: -5 }}
      className="relative group"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-white/5 rounded-2xl blur-xl group-hover:blur-2xl transition-all" />
      <div className="relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 h-full">
        <motion.div
          className="w-14 h-14 rounded-xl flex items-center justify-center mb-4"
          style={{ background: `linear-gradient(135deg, ${color}30, ${color}10)` }}
          whileHover={{ rotate: 5 }}
        >
          <Icon className="w-7 h-7" style={{ color }} />
        </motion.div>
        <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
        <p className="text-white/70 text-sm leading-relaxed">{description}</p>
      </div>
    </motion.div>
  );
}
